/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLastDashboardQuery } from '../../models/get-last-dashboard-query';
import { GetLastDashboardQueryResult } from '../../models/get-last-dashboard-query-result';

export interface ApiCommonDashboardGetLastDashboardPost$Params {
      body?: GetLastDashboardQuery
}

export function apiCommonDashboardGetLastDashboardPost(http: HttpClient, rootUrl: string, params?: ApiCommonDashboardGetLastDashboardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLastDashboardQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiCommonDashboardGetLastDashboardPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLastDashboardQueryResult>;
    })
  );
}

apiCommonDashboardGetLastDashboardPost.PATH = '/api/Common/Dashboard/GetLastDashboard';
